import React from 'react'
import { Stack } from '@mui/material';
import { categories } from '../utils/constant'

// const selectedCategory = 'New'
const Sidebar = ({ selectedCategory, setSelectedCategory }) => {
  return (
    <Stack
      direction='row'
      sx={{
        overflowY: "auto",
        height: { sx: "auto", md: "95%" },
        flexDirection: { md: 'column' }
      }}

    >
      {categories.map((category) => (
        <button
          className='category-btn'
          style={{
            background: category.name === selectedCategory && '#f27e0a', color: '#fff'
          }}
          onClick={() => setSelectedCategory(category.name)}
        >
          <span style={{ color: category.name === selectedCategory ? 'white' : '#f27e0a', marginRight: '15px' }}>
            {category.icon}
          </span>
          <span style={{ opecaty: category.name === selectedCategory ? '1' : '0' }}>
            {category.name}
          </span>
        </button>

      ))}
    </Stack>
  )
}

export default Sidebar;
